import { API } from "@/lib/api";
import { APIService, FetchListRequest } from "@/services/api";
import { ReadLaborCostsInStoresDepartmentBased } from "@/schemas/laborCostsInStores";
import { WriteInvoiceSpecificationStores } from "@/schemas/invoiceSpecificationForm";

const LaborCostsInStoresDepartmentBasedServiceAPI =
  new APIService<ReadLaborCostsInStoresDepartmentBased>(
    API.InvoiceSpecifications,
  );

export const laborCostsInStoresDepartmentBased = {
  getList: (
    settlementId: string,
    fetchParams?: FetchListRequest<ReadLaborCostsInStoresDepartmentBased>,
  ) =>
    LaborCostsInStoresDepartmentBasedServiceAPI.getList(
      fetchParams,
      `/${settlementId}/stores`,
    ),

  patch: (
    invoiceSpecificationId: string,
    values: WriteInvoiceSpecificationStores,
  ) =>
    LaborCostsInStoresDepartmentBasedServiceAPI.patch(
      invoiceSpecificationId,
      values,
    ),
};
